(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-editorial"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-editorial-article]').forEach((article) => {
    const content = article.querySelector('[data-article-content]');
    const toc = article.querySelector('[data-article-toc]');
    const list = article.querySelector('[data-article-toc-list]');
    if (!content || !toc || !list) return;

    const headings = [...content.querySelectorAll('h2')];
    if (headings.length < 2) return;

    headings.forEach((heading, index) => {
      const id = heading.id || `article-section-${index + 1}`;
      heading.id = id;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-appointment"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-calendar"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-event"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-location"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-apt-performer"] && !Shopify.designMode) return;
  try {
    
  /* Optional JS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["robingo-utility-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !link.closest('header-menu, header-drawer')) return;
    const destination = new URL(link.href, window.location.href);
    if (!['http:', 'https:'].includes(destination.protocol)) return;
    const isSectionLink = destination.origin === window.location.origin &&
      destination.pathname === window.location.pathname && destination.hash;
    if (isSectionLink) {
      link.removeAttribute('target');
      link.closest('header-drawer')?.querySelector('.menu-drawer__close-button')?.click();
    } else {
      link.target = '_blank';
      link.rel = 'noopener';
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
